import { Box } from "@mui/material";
import { FC, useState } from "react";
import { CalendarViewProps } from "../types";
import { getInitialSelectedYear, overWriteStartDate } from "../utils";
import { MonthsGrid } from "./MonthsGrid";
import { YearPicker } from "./YearPicker";

export const QuartersView: FC<CalendarViewProps> = ({
  tempStartDate,
  tempEndDate,
  setTempStartDate,
  setTempEndDate,
  earliestSelectableDate,
}) => {
  const [selectedYear, setSelectedYear] = useState<number>(
    getInitialSelectedYear(tempEndDate),
  );

  const handleQuarterSelect = (quarterIndex: number) => {
    const quarterStartMonth = quarterIndex * 3;
    const quarterEndMonth = quarterStartMonth + 2;
    const selectedQuarterStartDate = new Date(
      Date.UTC(selectedYear, quarterStartMonth, 1),
    );
    const quarterStartDate = overWriteStartDate(
      selectedQuarterStartDate,
      earliestSelectableDate,
    );
    const quarterEndDate = new Date(
      Date.UTC(selectedYear, quarterEndMonth + 1, 0),
    );

    if (!tempStartDate || tempEndDate) {
      setTempStartDate(quarterStartDate);
      setTempEndDate(null);
    } else {
      const startTime = tempStartDate.getTime();
      const selectedTime = quarterStartDate.getTime();

      if (selectedTime >= startTime) {
        setTempEndDate(quarterEndDate);
      } else {
        setTempStartDate(quarterStartDate);
        setTempEndDate(null);
      }
    }
  };

  const getQuarterFromMonth = (monthIndex: number): number => {
    return Math.floor(monthIndex / 3);
  };

  const handleMonthClick = (monthIndex: number) => {
    const quarterIndex = getQuarterFromMonth(monthIndex);
    handleQuarterSelect(quarterIndex);
  };

  const getDisplayEndDate = (): Date | null => {
    if (tempEndDate) {
      return tempEndDate;
    }

    if (tempStartDate) {
      const startMonth = tempStartDate.getUTCMonth();
      const startDay = tempStartDate.getUTCDate();
      const startYear = tempStartDate.getUTCFullYear();

      if (
        startDay === 1 &&
        startMonth % 3 === 0 &&
        startYear === selectedYear
      ) {
        const quarterEndMonth = startMonth + 2;

        return new Date(Date.UTC(startYear, quarterEndMonth + 1, 0));
      }
    }

    return null;
  };

  return (
    <Box>
      <YearPicker
        earliestSelectableDate={earliestSelectableDate}
        onYearChange={setSelectedYear}
        selectedYear={selectedYear}
      />
      <MonthsGrid
        earliestSelectableDate={earliestSelectableDate}
        endDate={getDisplayEndDate()}
        hoverByQuarter
        onMonthSelect={handleMonthClick}
        selectedYear={selectedYear}
        startDate={tempStartDate}
      />
    </Box>
  );
};
